import { EnderecoParmDTO } from "./address";
import { BaseFiltroPagDTO } from "./base-dto";

export class InstituicaoParmDTO {
  id: number;
  prospect: boolean;
  idUnidade: number;
  cnpj: string;
  nomeFantasia: string;
  razaoSocial: string;
  endereco: EnderecoParmDTO;

  qualificacao: string;
  temGrupoRede: boolean;
  nomeGrupoRede: string;

  qtdeLeitosUtiAdulto: number;
  qtdeLeitosUtiNeonato: number;
  qtdeLeitosUtiPediatrico: number;

  temEquipeMultiprof: boolean;
  responsavelEquipeMultiprof: string;

  usaRtu: boolean;
  rtus: Array<string>;
  rtusTiposPacientes: Array<string>;
  rtusVolumeMensal: number;

  usaNpManip: boolean;
  npManipFornecedores: Array<string>;
  npManipTiposPacientes: Array<string>;
  npManipVolumeMensal: number;

  temContratoVigente: boolean;
  dataVigenciaContrato: string;
  horarioLimitePrescricao: string;
  horarioLimiteEntrega: string;
  desospitalizComNp: boolean;

  idsContatos: Array<number>
}

export class InstituicaoFiltrosDTO extends BaseFiltroPagDTO {
  textoBusca: string;
  status: string;
  diasSemVisita: number;
  idVisitante: number;
  idContatoVinculado: number;
  idContatoVisitado: number;
  participacao: 'A' | 'V';
  prospect: boolean;
  planejamento: boolean;
  cdAreaGeo: string;
}

export class IndicadBolsasTipoPacFiltrosDTO {
  idInstituicao: number;
  bolsaMulti: boolean;
  meses: number;
}

export class IndicadBolsasMedicoFiltrosDTO {
  idInstituicao: number;
  bolsaMulti: boolean;
  meses: number;
}